import axios from 'axios';

export async function getLectureList(uid: number, dataToSubmit: any) {
  return await axios.post(
    `${process.env.REACT_APP_SERVER_BASE_URL}/manage/lectures/${uid}`,
    dataToSubmit
  );
}

export async function getLectureStudentList(lectureId: number, dataToSubmit: any) {
  return await axios.post(
    `${process.env.REACT_APP_SERVER_BASE_URL}/manage/lecture/students/${lectureId}`,
    dataToSubmit
  );
}
